const userLabel = require("../label/user");

const note_story_comment = {
  key: "note_story_comment",
  count_alias: "count_story_comments_new",
  label_activity: "story comments",
  label_data: "new story comment",
  label_detail: "A user posts a comment on a story I've published.",
  label_title: () => "New Comment On Your Story",
  label_zero_state:
    "When a user posts a comment on a story you've published, we'll notify you here.",
  makeNote: ({ isMentioned, ...user }) =>
    userLabel(user) +
    " posted a comment on your story" +
    (isMentioned ? " and mentioned you in it." : "."),
  makeLink: ({ id }) => "/comment/" + id,
  table: "comment",
  leftJoins: ["story", "author"],
  keys: [
    "comment.id AS id",
    "comment.created_at AS noted_at",
    "author.username AS username",
    "author.display_name AS display_name",
  ],
  wheres: [
    "story.author_id = ?",
    "comment.comment_reply_id IS NULL",
    "comment.author_id <> ?",
  ],
  where_since: {
    index: 1,
    sql: "comment.created_at >= ?",
    key: "note_last",
  },
  escapeValues: (user) => [user.id, user.id],
};

module.exports = note_story_comment;
